var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('comment',{attrs:{"comment":_vm.comment,"can-reply":""}},[_c('div',{attrs:{"slot":"media-right"},slot:"media-right"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }